export var DeductionKey;
(function (DeductionKey) {
    DeductionKey["HasSpouse"] = "hasSpouse";
    DeductionKey["ChildrenCount"] = "childrenCount";
    DeductionKey["ParentSupportCount"] = "parentSupportCount";
    DeductionKey["DisabledSupportCount"] = "disabledSupportCount";
    DeductionKey["LifeInsurance"] = "lifeInsurance";
    DeductionKey["HealthInsurance"] = "healthInsurance";
    DeductionKey["ParentHealthInsurance"] = "parentHealthInsurance";
    DeductionKey["Sso"] = "sso";
    DeductionKey["Pvd"] = "pvd";
    DeductionKey["Rmf"] = "rmf";
    DeductionKey["Ssf"] = "ssf";
    DeductionKey["Tesg"] = "tesg";
    DeductionKey["HomeLoanInterest"] = "homeLoanInterest";
    DeductionKey["NewHomeEReceipt"] = "newHomeEReceipt";
    DeductionKey["EasyEReceipt"] = "easyEReceipt";
    DeductionKey["EducationDonation"] = "educationDonation";
    DeductionKey["PoliticalDonation"] = "politicalDonation";
})(DeductionKey || (DeductionKey = {}));
//# sourceMappingURL=deduction-key.enum.js.map